import React from 'react';
// Context 可以让我们无须明确地传遍每一个组件，就能将值深入传递进组件树。
// 为当前的 BasicContext 创建一个 context（默认值为{}）。
export default React.createContext({});